<template>
    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="ibox-content m-b-sm border-bottom">
        <div class="row form-horizontal">
          <div class="form-group">
            <label class="col-sm-2 control-label">{{$t("message.userName") }}</label>
            <div class="col-sm-3">
              <div>
                <input
                  type="text"
                  v-model="searchName"
                  name="search"
                  class="form-control input"
                  maxLength="30"
                />
              </div>
            </div>
            <div class="col-sm-2">
              <div>
                <el-button type="primary" @click="search">{{$t("message.Search") }}</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">
              <div class="row table-responsive" style="padding-bottom:60px;">
                <div class="col-sm-12" >
                  <div class="pull-right">
                    <el-button
                      @click="gotoDetail"
                      v-if="checkPermission('USER_LIST_ADD')"
                    >{{$t("message.Add") }}</el-button>
                    <el-button 
                      @click="showWarning()" 
                      v-if="checkPermission('USER_LIST_DEL')"
                    >{{$t("message.Delete") }}</el-button>
                  </div>
                </div>
                <div class="col-xs-12">{{total}}{{$t("message.datagridresult") }}</div>
                <el-table :data="rows"
                           
                          sort 
                          style="width: 100%" 
                          :fit="true"
                          border ref="multipleTable" 
                          @selection-change="handleSelectionChange" 
                          @sort-change="sortChange" >
                  <el-table-column type="selection" width="55" ></el-table-column>
                  <el-table-column prop="userName" label='Username' min-width="200" ></el-table-column>
                  <el-table-column prop="email" :show-overflow-tooltip="true" label='Email' min-width="220" ></el-table-column>
                  <el-table-column prop="functionNames" label='Role' min-width="200" ></el-table-column>
                  <el-table-column prop="contactNo" label='Contact No' min-width="200" ></el-table-column>
                  <el-table-column prop="createdAt" v-bind:label='$t("message.createdTime")' width="170" ></el-table-column>
                  <el-table-column prop="status" v-bind:label='$t("message.Status")' width="120" >
                    <template slot-scope="scope">
                    {{ statusMap[scope.row.status] }}
                  </template>
                </el-table-column>
                  
                  <el-table-column
                    label="Action"
                    width="70"
                    fixed="right"
                  >
                    <template slot-scope="scope">
                       <el-button size="mini" @click="handleDbClick(scope.row)" icon="el-icon-edit" ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-col :span="24" class="el-table_footertoolbar">
                  <el-pagination 
                     layout="total, sizes, prev, pager, next, jumper" 
                     @size-change="handleSizeChange" 
                     @current-change="handleCurrentChange" 
                     :page-sizes="[10, 20, 50, 100]" 
                     :page-size="pagesize" 
                     :total="total" 
                     style="float:right;">
                  </el-pagination>
                </el-col>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  
  <script>
  import config from "../config";
  
  export default {
    name: "usefulLinksListController",
    mixins: [config.globalMixin],
    data() {
      return {
        page: 0,//当前页数
        pagesize:10,//一页显示几条
        filter: "",
        searchName: "",
        searchStatus: null,
        total:0,
        rows:[],
        multipleSelection:[],
        sortType:"ASC",
        sortField:"id",
      };
    },
    created: function() {
    },
    computed:{
        statusMap(){
            return {
                0:'Inactive',
                1:'Active'
            }
        },
        functionMap(){
            return {
                1:'Redeem Gift',
                2:'Publicity'
            }
        }
    },
    methods: {
      async init() {
        let objdata = this.getAuthObj();
        objdata.pageIndex = this.page
        objdata.pageSize = this.pagesize
        objdata.userName = this.searchName;
        objdata.apiUrl = this.apiConfig.externalUserList
        let data = await this.$store.dispatch("apiEvent", objdata);
        if(data == "000104"){
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        let list = null;
        for (list of data.data.result.externalUserList) {
          list.createdAt = this.dateFormat(list.createdAt)
          list.functionNames = ''
          if(list.functions){
            const functionList = list.functions.split(',')
            functionList.forEach((i,index)=>{
                list.functionNames += this.functionMap[i]
                if(index<functionList.length-1) list.functionNames += ','
            })
          }
          
        }
        this.rows = data.data.result.externalUserList;
        this.total = data.data.result.total;
      },
      gotoDetail() {
        this.$router.push({ path: "/main/externalUserDetail" });
      },
      async deleteList() {
        let ids = [];
        let objdata = this.getAuthObj();
        if (this.multipleSelection.length != 0) {
          for (let i = 0; i < this.multipleSelection.length; i++) {
            ids.push(this.multipleSelection[i].id);
          }
        }
        objdata.ids = ids;
  
        objdata.apiUrl = this.apiConfig.externalUserDelete
        let data = await this.$store.dispatch("apiEvent", objdata);
        if(data == "000104"){
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$store.commit("setwarning", {
            string: "",
            boolean: false,
            button: []
          });
          this.init();
        }
      },
      handleDbClick:function(row){
        this.$router.push({
          path: "/main/externalUserDetail",
          query: { id: row.id }
        });
      },
    },
    mounted() {
      this.init();
    }
  };
  </script>